// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2a4G1","content":"styles_content__7y5QN","selectAll":"styles_selectAll__1Rxw2"};